import { format } from 'date-fns';
import type {
  PlayersLeaderboardAlltimeDto,
  PlayersLeaderboardDto,
} from '@/api/backoffice-schemas';

export function formatTournamentDate(isoDate: string): string {
  const dateFormat = 'dd. MM.';
  return format(isoDate, dateFormat);
}

export function getLeaderboardPlayerUsername(
  player: PlayersLeaderboardDto | PlayersLeaderboardAlltimeDto
): string | undefined {
  if (isPlayersLeaderboardDto(player)) {
    return player.user?.userName ?? undefined;
  }
  return player.userName ?? undefined;
}

function isPlayersLeaderboardDto(obj: unknown): obj is PlayersLeaderboardDto {
  return typeof obj === 'object' && obj !== null && 'user' in obj;
}
